import React from 'react'
import styled from 'styled-components'

const StyledContainer = styled.div`
  height: 20px;
  box-sizing: border-box;
`

const StyledMessage = styled.div`
  font-size: 14px;
  font-weight: normal;
  color: #ff2600;
`

const FieldMessage = ({fieldName, errors}) => {
  const hasErrorMessage = errors[fieldName]
  return (
    <StyledContainer>
      {hasErrorMessage && <StyledMessage>{errors[fieldName]}</StyledMessage>}
    </StyledContainer>
  )
}

export default FieldMessage

FieldMessage.defaultProps = {
  errors: {}
}
